import {GeometryType} from "../../canvas/enums/geometry-type.enum";
import {PointField} from "../../canvas/enums/database/point-field.enum";
import {PolygonField} from "../../canvas/enums/database/polygon-field.enum";
import {PolygonShape} from "../../canvas/enums/polygon-shape.enum";
import {SphericalUtil} from "../../canvas/utils/spherical-util";

export class ProjectUtils{

  static getProjectBounds(pData){
    let minLat = 90;
    let minLng = 180;
    let maxLat = -90;
    let maxLng = -180;

    // Calculate the bounding box min and max

    pData.forEach(geo => {
      if (geo.type === GeometryType.TYPE_POLYGON) {
        if (geo.points) {
          let points = geo.points;
          if (!Array.isArray(geo.points)) {
            points = Object.values(points);
          }
          let latLngs: google.maps.LatLngLiteral[] = points.map(point =>
            ({lat: point[PointField.KEY_LAT], lng: point[PointField.KEY_LONG]}));
          // A circle stores only its centre and one point on the rim: its
          // extent is the outline, as Polygon.getPath() draws it.
          if (Number(geo[PolygonField.KEY_SHAPE]) === PolygonShape.CIRCLE && points.length > 1) {
            const ordered = [...points].sort((p1, p2) =>
              (p1[PointField.KEY_INDEX] ?? 0) - (p2[PointField.KEY_INDEX] ?? 0));
            const centre = {lat: ordered[0][PointField.KEY_LAT], lng: ordered[0][PointField.KEY_LONG]};
            const rim = {lat: ordered[1][PointField.KEY_LAT], lng: ordered[1][PointField.KEY_LONG]};
            latLngs = SphericalUtil.getCirclePoints(centre, SphericalUtil.computeDistanceBetween(centre, rim));
          }
          latLngs.forEach(point => {
            const lat = point.lat;
            const lng = point.lng;
            if (lat < minLat) {
              minLat = lat;
            }
            if (lat > maxLat) {
              maxLat = lat;
            }
            if (lng < minLng) {
              minLng = lng;
            }
            if (lng > maxLng) {
              maxLng = lng;
            }
          })
        }
      } else if (geo.type === GeometryType.TYPE_SPOT) {
        const lat = geo[PointField.KEY_LAT];
        const lng = geo[PointField.KEY_LONG];
        if (lat < minLat) {
          minLat = lat;
        }
        if (lat > maxLat) {
          maxLat = lat;
        }
        if (lng < minLng) {
          minLng = lng;
        }
        if (lng > maxLng) {
          maxLng = lng;
        }
      }
    });

    return {
      minLat: minLat,
      minLng: minLng,
      maxLat: maxLat,
      maxLng: maxLng
    };
  }
}
